import Repository from '@/libs/axios'
import ListsRepository from '@/libs/customAxios/listsAxios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const trackingSettingsPublicResource = '/settings/tracking'
const trackingSettingsLogoResource = '/admin/settings/general/tracking-image'
const trackingSettingsAdvanceResource = '/admin/order/tracking-info/advance-tracking-details'
const trackingSettingsValueResource = '/admin/settings/general/advance-tracking-details'
const trackingPageTemplatesResource = '/admin/settings/tracking-page-templates'

const defaultPagination = 20
export default {
  getCurrentLogo() {
    return OperationsRepository.get(`${trackingSettingsPublicResource}`)
  },
  saveBackgroundImage(payload) {
    const formData = new FormData()
    formData.append('file', payload)
    return Repository.post(`${trackingSettingsLogoResource}`, formData)
  },
  getAdvanceTrackingList(pageNumber, pagination = defaultPagination) {
    return OperationsRepository.get(`${trackingSettingsAdvanceResource}?paginate=${pagination}&page=${pageNumber}&sort=-id`)
  },
  setActiveStatus(id, payload) {
    return Repository.put(`${trackingSettingsAdvanceResource}/${id}`, payload)
  },
  updateAdvanceTrackingValue(payload) {
    return Repository.put(`${trackingSettingsValueResource}`, payload)
  },
  fetchAdvanceTrackingListNoPagination() {
    return ListsRepository.get(`${trackingSettingsAdvanceResource}?noPagination`)
  },
  getTrackingPageTemplates(pageNumber = 1, pagination = 10) {
    return Repository.get(`${trackingPageTemplatesResource}?paginate=${pagination}&page=${pageNumber}`)
  },
  getTrackingPageTemplateStatuses() {
    return Repository.get(`${trackingPageTemplatesResource}/statuses`)
  },
  getTrackingPageTemplate(id) {
    return Repository.get(`${trackingPageTemplatesResource}/show?id=${id}`)
  },
  createTrackingPageTemplate(payload) {
    return Repository.post(`${trackingPageTemplatesResource}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  updateTrackingPageTemplateImage(id, payload) {
    return Repository.post(`${trackingPageTemplatesResource}/${id}/image`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getTrackingPageTemplateAssignedMerchants(id, pageNumber = 1, pagination = 20) {
    return Repository.get(`${trackingPageTemplatesResource}/${id}/assigned-merchants`, {
      params: {
        page: pageNumber,
        paginate: pagination,
      },
    })
  },
  assignTrackingPageTemplateMerchants(id, payload) {
    return Repository.put(`${trackingPageTemplatesResource}/${id}/assign-merchants`, payload)
  },
}
